<template>
  <section class="hero">
    <div class="hero-left">
      <p class="hero-eyebrow">Collaborate With Us</p>
      <h1 v-if="title" class="hero-title">{{ title }}</h1>
      <h1 v-else class="hero-title">Work<br />With <em>Us</em></h1>
      <p class="hero-sub">
        Join the Hooligans Eyewear family. We're always looking for passionate
        creators and fashion lovers to grow with us.
      </p>
    </div>
    <div class="hero-right">
      <MediaSlotImage
        slot-code="work.hero"
        :fallback="heroImage"
        alt="Hooligans Eyewear lifestyle"
        sizes="(max-width: 767px) 100vw, 50vw"
        :width="960"
        :height="1200"
        loading="eager"
        fetchpriority="high"
      />
      <div class="hero-right-overlay"></div>
    </div>
  </section>
</template>

<script>
import { cdnUrl } from "~/utils/cdn";
import MediaSlotImage from "~/core/components/atoms/media-slot-image/media-slot-image.vue";

export default {
  name: "WorkWithUsHero",
  components: { MediaSlotImage },
  props: {
    title: {
      type: String,
      default: "",
    },
    heroImage: {
      type: String,
      default: () =>
        cdnUrl("/image/HOOLIGANS+WEB/Work+With+Us/Home+Page+Slideshow+(1).png"),
    },
  },
};
</script>
